var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOutdoorsyChart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 792,
  height: 346,
  fill: "none",
  viewBox: "0 0 792 346"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M538.45 168.012c-50.6 34.196-156.2 101.104-217.8 109.904s-146.3 25.3-211.2 25.3H0v42.687h790.9V1.053c0 19.037-36.85 31.562-88.55 66.762s-113.3 66.001-163.9 100.197"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 33.757,
  cy: 303.973,
  r: 3.507,
  fill: "#E5B021"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 109.107,
  cy: 302.873,
  r: 3.507,
  fill: "#E5B021"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 177.857,
  cy: 299.572,
  r: 3.507,
  fill: "#E5B021"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 252.657,
  cy: 286.922,
  r: 3.507,
  fill: "#E5B021"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 323.607,
  cy: 276.473,
  r: 3.507,
  fill: "#E5B021"
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 395.657,
  cy: 252.822,
  r: 3.507,
  fill: "#E5B021"
})), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
  cx: 467.707,
  cy: 213.773,
  r: 3.507,
  fill: "#E5B021"
})), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
  cx: 539.207,
  cy: 169.773,
  r: 3.507,
  fill: "#E5B021"
})), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
  cx: 611.257,
  cy: 126.872,
  r: 3.507,
  fill: "#E5B021"
})), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
  cx: 682.207,
  cy: 84.523,
  r: 3.507,
  fill: "#E5B021"
})), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
  cx: 754.257,
  cy: 36.123,
  r: 3.507,
  fill: "#E5B021"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#252422",
  d: "M26.194 323.035v-.708a2.2 2.2 0 0 1 1.247-.362q.816 0 1.31.492.492.486.492 1.263 0 .255-.062.539-.06.27-.223.562l-.277.493q-.1.17-.424.562a30.344 30.344 0 0 1-.947 1.086h2.202v.639h-3.595q1.462-1.647 1.817-2.133.73-1.009.747-1.732 0-.494-.3-.786-.3-.3-.81-.3-.638 0-1.177.385m7.5 4.658q-.948 0-1.525-.808t-.577-2.056.577-2.056q.577-.808 1.525-.808.947 0 1.524.808t.578 2.056-.578 2.056-1.524.808m0-5.043q-.617 0-.986.601-.37.6-.37 1.578t.37 1.579.986.6q.615 0 .985-.6.37-.601.37-1.579t-.37-1.578-.985-.601m4.292.046v-.639h1.433v5.544h-.74v-4.905zm7.184 3.573v1.332h-.663v-1.332h-2.625l1.91-4.212h.739l-1.61 3.581h1.594v-1.448h.655v1.448h.77v.631zM98.296 323.035v-.708a2.2 2.2 0 0 1 1.247-.362q.816 0 1.309.492.492.486.493 1.263 0 .255-.062.539-.061.27-.223.562l-.277.493q-.1.17-.424.562-.277.34-.431.508-.023.032-.516.578h2.202v.639h-3.596q1.463-1.647 1.817-2.133.732-1.009.747-1.732 0-.494-.3-.786-.3-.3-.808-.3-.64 0-1.178.385m7.499 4.658q-.947 0-1.524-.808t-.578-2.056q0-1.248.578-2.056t1.524-.808q.948 0 1.525.808t.577 2.056-.577 2.056-1.525.808m0-5.043q-.615 0-.985.601-.37.6-.37 1.578t.37 1.579.985.6q.616 0 .986-.6.369-.601.369-1.579t-.369-1.578q-.37-.601-.986-.601m4.293.046v-.639h1.432v5.544h-.739v-4.905zm4.088 4.636v-.678q.516.378 1.247.377.57 0 .924-.315.355-.317.355-.84a1.01 1.01 0 0 0-.37-.816q-.362-.308-.932-.308-.608 0-1.093.223l.115-2.918h2.703v.639h-2.048l-.062 1.525q.27-.1.639-.1.778 0 1.294.508.516.492.516 1.309 0 .801-.555 1.278-.546.477-1.416.477-.778 0-1.317-.361M169.877 323.035v-.708a2.18 2.18 0 0 1 1.247-.362q.816 0 1.309.492.493.486.493 1.263 0 .255-.062.539-.061.27-.223.562l-.277.493q-.1.17-.424.562-.277.34-.431.508-.023.032-.516.578h2.202v.639h-3.596q1.463-1.647 1.818-2.133.73-1.009.746-1.732 0-.494-.3-.786-.3-.3-.808-.3a1.98 1.98 0 0 0-1.178.385m7.499 4.658q-.946 0-1.524-.808t-.578-2.056.578-2.056 1.524-.808q.948 0 1.525.808t.577 2.056-.577 2.056-1.525.808m0-5.043q-.615 0-.985.601-.37.6-.37 1.578t.37 1.579.985.6q.616 0 .986-.6.369-.601.369-1.579t-.369-1.578q-.37-.601-.986-.601m4.293.046v-.639h1.432v5.544h-.739v-4.905zm6.098 1.332q.785 0 1.309.532.516.523.516 1.285 0 .794-.547 1.325-.547.523-1.363.523-.809 0-1.355-.523-.531-.531-.532-1.355 0-.955.717-2.049.731-1.109 1.54-1.709h.977a8 8 0 0 0-1.201 1.093 7.4 7.4 0 0 0-.885 1.171q.339-.293.824-.293m-.085 3.042q.531 0 .87-.347a1.2 1.2 0 0 0 .347-.878 1.19 1.19 0 0 0-1.217-1.224 1.2 1.2 0 0 0-.878.347q-.339.339-.339.854 0 .555.339.901.34.347.878.347M242.129 323.035v-.708a2.18 2.18 0 0 1 1.247-.362q.816 0 1.309.492.493.486.493 1.263 0 .255-.062.539-.061.27-.223.562l-.277.493q-.1.17-.424.562-.277.34-.431.508-.022.032-.516.578h2.202v.639h-3.596q1.463-1.647 1.818-2.133.73-1.009.746-1.732 0-.494-.3-.786-.3-.3-.808-.3a1.98 1.98 0 0 0-1.178.385m7.499 4.658q-.947 0-1.524-.808t-.578-2.056q0-1.248.578-2.056.577-.808 1.524-.808t1.525.808q.577.808.577 2.056t-.577 2.056-1.525.808m0-5.043q-.615 0-.985.601-.37.6-.37 1.578t.37 1.579.985.6q.616 0 .986-.6.369-.601.369-1.579t-.369-1.578q-.37-.601-.986-.601m4.293.046v-.639h1.432v5.544h-.739v-4.905zm7.353-.639-2.395 5.544h-.785l2.163-4.905h-2.556v-.639z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#b)",
  strokeWidth: 0.55,
  d: "M0-.275h317.9",
  opacity: 0.2,
  transform: "matrix(0 -1 -1 0 72.05 333.803)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#c)",
  strokeWidth: 0.55,
  d: "M0-.275h317.9",
  opacity: 0.2,
  transform: "matrix(0 -1 -1 0 0 333.803)"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#d)",
  strokeWidth: 0.55,
  d: "M0-.275h317.9",
  opacity: 0.2,
  transform: "matrix(0 -1 -1 0 143.55 333.803)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#e)",
  strokeWidth: 0.55,
  d: "M0-.275h317.9",
  opacity: 0.2,
  transform: "matrix(0 -1 -1 0 215.6 333.803)"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#f)",
  strokeWidth: 0.55,
  d: "M0-.275h317.9",
  opacity: 0.2,
  transform: "matrix(0 -1 -1 0 287.65 333.803)"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#252422",
  d: "M313.822 323.035v-.708q.54-.363 1.248-.362.816 0 1.309.492.492.486.493 1.263 0 .255-.062.539-.062.27-.223.562l-.278.493q-.099.17-.423.562-.278.34-.431.508-.024.032-.516.578h2.202v.639h-3.596q1.463-1.647 1.817-2.133.732-1.009.747-1.732 0-.494-.3-.786-.3-.3-.809-.3-.639 0-1.178.385m7.5 4.658q-.947 0-1.525-.808-.577-.808-.577-2.056t.577-2.056 1.525-.808 1.525.808.577 2.056-.577 2.056-1.525.808m0-5.043q-.616 0-.986.601-.369.6-.369 1.578t.369 1.579.986.6q.616 0 .986-.6.369-.601.369-1.579t-.369-1.578-.986-.601m4.293.046v-.639h1.432v5.544h-.739v-4.905zm5.22 2.087a2 2 0 0 1-.732-.547 1.35 1.35 0 0 1-.315-.878q0-.6.469-1.001.47-.4 1.186-.4.708 0 1.178.4.478.408.478 1.001 0 .494-.316.878a2 2 0 0 1-.732.547q.5.231.817.593.346.377.346.901 0 .616-.5 1.024-.494.4-1.271.4-.778 0-1.278-.4-.501-.408-.501-1.024 0-.5.324-.886.33-.392.847-.608m-.462 1.417q0 .377.308.616a1.2 1.2 0 0 0 .762.246q.454 0 .755-.246a.76.76 0 0 0 .308-.616q0-.347-.293-.647a2.1 2.1 0 0 0-.77-.485 2.2 2.2 0 0 0-.778.485q-.292.3-.292.647m.123-2.78q0 .654.947 1.063.947-.409.947-1.063a.75.75 0 0 0-.277-.593.98.98 0 0 0-.67-.239 1 1 0 0 0-.678.239.76.76 0 0 0-.269.593M385.672 323.035v-.708a2.2 2.2 0 0 1 1.248-.362q.816 0 1.309.492.492.486.492 1.263 0 .255-.061.539-.062.27-.224.562l-.277.493a6 6 0 0 1-.423.562q-.278.34-.431.508-.024.032-.516.578h2.202v.639h-3.596q1.463-1.647 1.817-2.133.732-1.009.747-1.732 0-.494-.3-.786-.3-.3-.809-.3a1.98 1.98 0 0 0-1.178.385m7.5 4.658q-.948 0-1.525-.808t-.577-2.056.577-2.056 1.525-.808q.947 0 1.524.808t.578 2.056-.578 2.056q-.577.808-1.524.808m0-5.043q-.616 0-.986.601-.369.6-.369 1.578t.369 1.579q.37.6.986.6t.985-.6q.37-.601.37-1.579t-.37-1.578-.985-.601m4.293.046v-.639h1.432v5.544h-.739v-4.905zm5.797 2.934q-.786 0-1.309-.531a1.76 1.76 0 0 1-.516-1.286q0-.794.539-1.325.538-.531 1.371-.531.808 0 1.339.531.54.531.539 1.355 0 .955-.716 2.049-.716 1.101-1.532 1.709h-.978a8.2 8.2 0 0 0 1.201-1.086q.547-.608.886-1.178a1.22 1.22 0 0 1-.824.293m.085-3.049q-.532 0-.878.354a1.22 1.22 0 0 0-.339.878q0 .523.339.877.346.347.878.347.531 0 .87-.339a1.17 1.17 0 0 0 .346-.862q0-.555-.339-.901-.338-.354-.877-.354M456.633 323.035v-.708a2.18 2.18 0 0 1 1.247-.362q.817 0 1.309.492.493.486.493 1.263 0 .255-.062.539-.061.27-.223.562l-.277.493q-.1.17-.424.562a12 12 0 0 1-.431.508q-.023.032-.516.578h2.202v.639h-3.595q1.463-1.647 1.817-2.133.73-1.009.747-1.732 0-.494-.301-.786-.3-.3-.808-.3a1.98 1.98 0 0 0-1.178.385m7.499 4.658q-.946 0-1.524-.808t-.578-2.056.578-2.056q.577-.808 1.524-.808t1.525.808.578 2.056-.578 2.056q-.577.808-1.525.808m0-5.043q-.615 0-.985.601-.37.6-.37 1.578t.37 1.579.985.6q.617 0 .986-.6.37-.601.37-1.579t-.37-1.578-.986-.601m4.158.385v-.708a2.18 2.18 0 0 1 1.247-.362q.816 0 1.309.492.493.486.493 1.263 0 .255-.062.539-.061.27-.223.562l-.277.493q-.1.17-.424.562-.277.34-.431.508-.023.032-.516.578h2.202v.639h-3.596q1.463-1.647 1.818-2.133.73-1.009.746-1.732 0-.494-.3-.786-.3-.3-.808-.3a1.98 1.98 0 0 0-1.178.385m7.499 4.658q-.947 0-1.524-.808t-.578-2.056.578-2.056q.577-.808 1.524-.808t1.525.808q.577.808.577 2.056t-.577 2.056-1.525.808m0-5.043q-.615 0-.985.601-.37.6-.37 1.578t.37 1.579.985.6q.616 0 .986-.6.369-.601.369-1.579t-.369-1.578-.986-.601M529.667 323.035v-.708a2.18 2.18 0 0 1 1.247-.362q.816 0 1.309.492.493.486.493 1.263 0 .255-.062.539-.061.27-.223.562l-.277.493q-.1.17-.424.562a12 12 0 0 1-.431.508q-.023.032-.516.578h2.203v.639h-3.596q1.463-1.647 1.817-2.133.731-1.009.747-1.732 0-.494-.301-.786-.3-.3-.808-.3a1.98 1.98 0 0 0-1.178.385m7.5 4.658q-.948 0-1.525-.808-.578-.808-.578-2.056t.578-2.056q.577-.808 1.525-.808.946 0 1.524.808t.578 2.056-.578 2.056-1.524.808m0-5.043q-.617 0-.986.601-.37.6-.37 1.578t.37 1.579.986.6q.615 0 .985-.6.37-.601.37-1.579t-.37-1.578-.985-.601m4.157.385v-.708a2.18 2.18 0 0 1 1.247-.362q.816 0 1.309.492.493.486.493 1.263 0 .255-.062.539-.061.27-.223.562l-.277.493q-.1.17-.424.562-.277.34-.431.508-.022.032-.516.578h2.202v.639h-3.596q1.463-1.647 1.818-2.133.73-1.009.747-1.732 0-.494-.301-.786-.3-.3-.808-.3a1.98 1.98 0 0 0-1.178.385m5.426-.339v-.639h1.432v5.544h-.739v-4.905z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#g)",
  strokeWidth: 0.55,
  d: "M0-.275h317.9",
  opacity: 0.2,
  transform: "matrix(0 -1 -1 0 359.7 333.803)"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#h)",
  strokeWidth: 0.55,
  d: "M0-.275h317.9",
  opacity: 0.2,
  transform: "matrix(0 -1 -1 0 287.65 333.803)"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#i)",
  strokeWidth: 0.55,
  d: "M0-.275h317.9",
  opacity: 0.2,
  transform: "matrix(0 -1 -1 0 431.2 333.803)"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#j)",
  strokeWidth: 0.55,
  d: "M0-.275h317.9",
  opacity: 0.2,
  transform: "matrix(0 -1 -1 0 503.25 333.803)"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#k)",
  strokeWidth: 0.55,
  d: "M0-.275h317.9",
  opacity: 0.2,
  transform: "matrix(0 -1 -1 0 575.3 333.803)"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#252422",
  d: "M600.898 323.035v-.708q.54-.363 1.248-.362.816 0 1.309.492.492.486.492 1.263 0 .255-.061.539-.062.27-.224.562l-.277.493a5 5 0 0 1-.423.562q-.278.34-.431.508-.024.032-.516.578h2.202v.639h-3.596q1.463-1.647 1.817-2.133.732-1.009.747-1.732 0-.494-.3-.786-.3-.3-.809-.3-.639 0-1.178.385m7.5 4.658q-.947 0-1.525-.808-.577-.808-.577-2.056t.577-2.056 1.525-.808 1.525.808.577 2.056-.577 2.056-1.525.808m0-5.043q-.616 0-.986.601-.369.6-.369 1.578t.369 1.579.986.6q.616 0 .986-.6.369-.601.369-1.579t-.369-1.578-.986-.601m4.157.385v-.708a2.18 2.18 0 0 1 1.247-.362q.817 0 1.309.492.493.486.493 1.263 0 .255-.061.539-.062.27-.224.562l-.277.493a6 6 0 0 1-.423.562 13 13 0 0 1-.432.508q-.022.032-.516.578h2.203v.639h-3.596q1.463-1.647 1.817-2.133.732-1.009.747-1.732 0-.494-.3-.786-.301-.3-.809-.3a1.98 1.98 0 0 0-1.178.385m5.403 0v-.708q.54-.363 1.248-.362.816 0 1.309.492.493.486.493 1.263 0 .255-.062.539-.061.27-.223.562l-.277.493q-.1.17-.424.562-.277.34-.431.508-.023.032-.516.578h2.202v.639h-3.596q1.463-1.647 1.817-2.133.732-1.009.747-1.732 0-.494-.3-.786-.3-.3-.808-.3-.639 0-1.179.385M672.917 323.035v-.708a2.2 2.2 0 0 1 1.248-.362q.816 0 1.309.492.492.486.492 1.263 0 .255-.061.539-.062.27-.224.562l-.277.493a6 6 0 0 1-.423.562q-.278.34-.431.508-.024.032-.516.578h2.202v.639h-3.596q1.463-1.647 1.817-2.133.732-1.009.747-1.732 0-.494-.3-.786-.3-.3-.809-.3a1.98 1.98 0 0 0-1.178.385m7.5 4.658q-.948 0-1.525-.808t-.577-2.056.577-2.056 1.525-.808q.946 0 1.524.808t.578 2.056-.578 2.056-1.524.808m0-5.043q-.616 0-.986.601-.369.6-.369 1.578t.369 1.579.986.6q.616 0 .985-.6.37-.601.37-1.579t-.37-1.578-.985-.601m4.157.385v-.708a2.18 2.18 0 0 1 1.247-.362q.817 0 1.309.492.493.486.493 1.263 0 .255-.061.539-.062.27-.224.562l-.277.493a6 6 0 0 1-.423.562 13 13 0 0 1-.432.508q-.023.032-.516.578h2.203v.639h-3.596q1.463-1.647 1.817-2.133.732-1.009.747-1.732 0-.494-.3-.786-.301-.3-.809-.3a1.98 1.98 0 0 0-1.178.385m7.536.477q0-.415-.292-.646-.293-.24-.801-.239-.609 0-1.17.285v-.678a2.9 2.9 0 0 1 1.262-.269q.809 0 1.286.408.485.408.485 1.062 0 .454-.277.801a1.6 1.6 0 0 1-.731.508q.492.139.793.524.308.385.308.901 0 .67-.524 1.101-.516.423-1.34.423-.77 0-1.363-.308v-.677q.648.323 1.317.323.509 0 .824-.254a.84.84 0 0 0 .316-.677q0-.5-.385-.778-.378-.277-1.063-.277h-.162v-.586h.224q.561 0 .924-.261.369-.262.369-.686M744.509 323.035v-.708q.54-.363 1.248-.362.816 0 1.309.492.492.486.493 1.263 0 .255-.062.539-.061.27-.223.562l-.277.493q-.1.17-.424.562-.278.34-.431.508-.024.032-.516.578h2.202v.639h-3.596q1.463-1.647 1.817-2.133.732-1.009.747-1.732 0-.494-.3-.786-.3-.3-.808-.3-.64 0-1.179.385m7.5 4.658q-.947 0-1.524-.808t-.578-2.056.578-2.056q.577-.808 1.524-.808t1.525.808.577 2.056-.577 2.056-1.525.808m0-5.043q-.616 0-.985.601-.37.6-.37 1.578t.37 1.579.985.6q.616 0 .986-.6.369-.601.369-1.579t-.369-1.578-.986-.601m4.157.385v-.708q.54-.363 1.248-.362.816 0 1.309.492.492.486.492 1.263 0 .255-.061.539-.062.27-.224.562l-.277.493a5 5 0 0 1-.423.562q-.278.34-.431.508-.024.032-.516.578h2.202v.639h-3.596q1.463-1.647 1.817-2.133.732-1.009.747-1.732 0-.494-.3-.786-.3-.3-.809-.3-.639 0-1.178.385m8.53 3.234v1.332h-.662v-1.332h-2.626l1.91-4.212h.739l-1.609 3.581h1.593v-1.448h.655v1.448h.77v.631z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#l)",
  strokeWidth: 0.55,
  d: "M0-.275h317.9",
  opacity: 0.2,
  transform: "matrix(0 -1 -1 0 646.8 333.803)"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#m)",
  strokeWidth: 0.55,
  d: "M0-.275h317.9",
  opacity: 0.2,
  transform: "matrix(0 -1 -1 0 575.3 333.803)"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#n)",
  strokeWidth: 0.55,
  d: "M0-.275h317.9",
  opacity: 0.2,
  transform: "matrix(0 -1 -1 0 718.85 333.803)"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#o)",
  strokeWidth: 0.55,
  d: "M0-.275h317.9",
  opacity: 0.2,
  transform: "matrix(0 -1 -1 0 790.9 333.803)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 398.75,
  x2: 398.75,
  y1: 251.515,
  y2: 328.515,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5B021",
  stopOpacity: 0.13
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E5B021",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 0,
  x2: 317.9,
  y1: 0,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 0,
  x2: 317.9,
  y1: 0,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: 0,
  x2: 317.9,
  y1: 0,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: 0,
  x2: 317.9,
  y1: 0,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: 0,
  x2: 317.9,
  y1: 0,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "g",
  x1: 0,
  x2: 317.9,
  y1: 0,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "h",
  x1: 0,
  x2: 317.9,
  y1: 0,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "i",
  x1: 0,
  x2: 317.9,
  y1: 0,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "j",
  x1: 0,
  x2: 317.9,
  y1: 0,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "k",
  x1: 0,
  x2: 317.9,
  y1: 0,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "l",
  x1: 0,
  x2: 317.9,
  y1: 0,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "m",
  x1: 0,
  x2: 317.9,
  y1: 0,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "n",
  x1: 0,
  x2: 317.9,
  y1: 0,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "o",
  x1: 0,
  x2: 317.9,
  y1: 0,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})))));
export default SvgOutdoorsyChart;